import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Core Java</h1>
            <br />
          </div>
          <div className="imgSection">
            <img src={require("../../../images/courses/Java.png")} alt="" />
          </div>
          <div className="heading">
            <h4 style={{ color: "blue" }}>Introduction</h4>
            <ul>
              <li>
                JAVA is a general-purpose server-side scripting language
                originally designed for Web development to produce dynamic web
                pages. This is a three /four day course designed for the
                beginners to understand the JAVA Programming.
              </li>
            </ul>

            <h4 style={{ color: "blue" }}>Course Objective</h4>
            <ul>
              <li>
                Learn the syntax, semantics and idioms of the Java programming
                language. Gain confidence in object-oriented programming
                principles through lots of practical exercises.{" "}
              </li>
            </ul>

            <h4 style={{ color: "blue" }}>Prerequisite</h4>
            <ul>
              <li>
                No experience is required but fundamental knowledge of object
                oriented programming using C++ would be helpful.
              </li>
            </ul>

            <h3 style={{ color: "blue" }}>Course Content</h3>

            <h4>Introduction to Java Programming</h4>
            <ul>
              <li>Java History </li>
              <li>Features of Java Programming</li>
              <li>
                Writing, Compiling and executing Java Classes/ Program using
                Notepad and eclipse{" "}
              </li>
              <li>Hello world Using Notepad and Eclipse IDE </li>
              <li>Primitive Data Types in Java </li>
              <li>
                More examples using primitive types and other language
                constructs.{" "}
              </li>
            </ul>

            <h4>More on Java Program</h4>
            <ul>
              <li>Defining Classes, Field Declaration, Method declaration </li>
              <li>Scope –public, private, Protected </li>
              <li>Creating Objects, Accessing Class Members </li>
              <li>Constructor </li>
              <li>Constructor / Method Overloading </li>
              <li>Static and non static methods and fields </li>
              <li>Arrays </li>
              <li>Passing Parameters </li>
            </ul>

            <h4>Arrays, String, Vector</h4>
            <ul>
              <li>Introduction </li>
              <li>One Dimensional Array </li>
              <li>Creating Arrays </li>
              <li>Two Dimensional Arrays </li>
              <li>String and String Class Methods </li>
              <li>Vector </li>
              <li>Wrapper Classes </li>
              <li>Enumerated Types </li>
            </ul>

            <h4>Inheritance and Polymorphism</h4>
            <ul>
              <li>Extending Classes </li>
              <li>Defining Subclasses </li>
              <li>Multilevel Inheritance </li>
              <li>Hierarchical Inheritance </li>
              <li>Overriding methods </li>
              <li>Final Variable and Methods </li>
              <li>Finalizer Method </li>
              <li>Abstract Method & Class </li>
            </ul>

            <h4>Interface: Multiple Inheritance</h4>
            <ul>
              <li>Introduction </li>
              <li>Defining Interfaces </li>
              <li>Extending Interfaces </li>
              <li>Implementing Interfaces </li>
              <li>Accessing Interfacing </li>
            </ul>

            <h4>Packages: Putting Class Together</h4>
            <ul>
              <li>Introduction </li>
              <li>Java API Packages </li>
              <li>Using System Packages </li>
              <li>Naming Conversations </li>
              <li>Creating Packages </li>
              <li>Using Packages </li>
              <li>Adding Classes to Package </li>
              <li>Hiding Classes </li>
            </ul>

            <h4>Errors and Exceptions</h4>
            <ul>
              <li>Introduction </li>
              <li>Types of Errors </li>
              <li>Exceptions </li>
              <li>Syntax of Exception Handling Code </li>
              <li>Multiple Catch Statements </li>
              <li>Using Finally Statements </li>
              <li>Throwing our own Exceptions4 </li>
            </ul>

            <h4>Multithreading Programming</h4>
            <ul>
              <li>Introduction </li>
              <li>Thread Life Cycle </li>
              <li>Creating Thread </li>
              <li>Extending Thread Class </li>
              <li>Stopping and Blocking Thread </li>
              <li>Using Thread Class Methods </li>
              <li>Thread Exceptions </li>
              <li>Thread Priority </li>
              <li>Synchronization </li>
            </ul>

            <h4>Managing Input output Files in Java</h4>
            <ul>
              <li>Introduction </li>
              <li>Concepts of Streams </li>
              <li>Stream Classes </li>
              <li>Byte Stream Classes </li>
              <li>Character Stream Classes </li>
              <li>Using Stream </li>
              <li>Using File Classes </li>
              <li>I/O Exceptions </li>
              <li>Creating Files </li>
              <li>Reading Wring Character </li>
              <li>Reading Wring Bytes </li>
              <li>Handling Primitive Data Types </li>
              <li>Other Stream Classes </li>
            </ul>

            <h4>Java Collections</h4>
            <ul>
              <li>Introduction </li>
              <li>
                Overview of Collection Interfaces such as Set, List, SortedList,
                Queue, Map, SortedMap, Iterator{" "}
              </li>
              <li>
                Overview of Collection Classes such as AbstractCollection,
                AbstractList, ArraryList, LinkedList, HashList,TreeSet,
                HashSet,Vector,Stack, HashTable{" "}
              </li>
            </ul>

            <h4>GUI Using Java (AWT & Swing)</h4>
            <ul>
              <li>Java AWT Basics and Hierarchy </li>
              <li>Event Handling Model </li>
              <li>Overview of AWT Container and components </li>
              <li>AWT Listeners </li>
              <li>Java Swing introduction </li>
              <li>Difference between AWT and Swing </li>
              <li>Overview of Java Swing Components and Containers </li>
              <li>Different Layout Managers </li>
            </ul>

            <h4>Applet Programming</h4>
            <ul>
              <li>Introduction </li>
              <li>How Applet Differs from Application </li>
              <li>Preparing to Write Applet </li>
              <li>Building Applet Code </li>
              <li>Applet Life Cycle </li>
              <li>Creating an Executable Applet </li>
              <li>Designing Webpage </li>
              <li>Adding Applet Tag </li>
              <li>Running Applet </li>
              <li>Passing Parameter to Applet </li>
              <li>Getting Input from User </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
